import { finishCall } from '@gem/call/Model/callModel';
import { FinishCallReason } from '@gem/call/Model/callModel.types';

import Tasks from 'APP/Tasks';
import { AudioSourceType } from 'APP/constants/app';
import { leaveGroup as leaveGroupModel } from 'APP/model/group/groupModel';
import { GroupUserRole } from 'APP/model/group/groupModel.types';
import Entities from 'STORE';

async function request(groupId: string): Promise<{ error: null | string }> {
  try {
    await leaveGroupModel(groupId);
    return {
      error: null,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
}

export const leaveGroup = async ({
  groupId,
}: {
  groupId: string;
}): Promise<{ error: null | string }> => {
  if (groupId === Entities.GroupsStore.activeGroup?.id) {
    Tasks.group.setActiveGroup({ groupId: null });
  }

  const group = Entities.GroupsStore.getGroupById(groupId);

  if (!group) {
    return { error: null };
  }

  const call = Entities.Calls.getCallByGroupId(groupId);

  if (call) {
    Tasks.app.audioSource.removeSource(AudioSourceType.Call);

    const isOwnerOrAdmin = group.isOwner || group.isAdmin;
    const isP2p = group.isP2P;
    const isInitiator = call.isInitiator;
    const isFinishToAll = isOwnerOrAdmin || isP2p || isInitiator;

    if (isFinishToAll && call.channelId) {
      await finishCall(call.channelId, FinishCallReason.FinishAll);
    }

    Entities.Calls.delete(call.groupId, call.channelId);
  }

  const { error } = await request(groupId);
  if (error) {
    return { error };
  }

  if ((group.isChatGroup || group.isChannel) && group.isOpen) {
    group.setUserGroupRole(GroupUserRole.Guest);
    Entities.Counters.delete(groupId);
  } else {
    Tasks.group.removeGroupLocally({ groupId, alert: undefined });
  }

  return { error: null };
};
